/* Callisto SE: open the existing browser cart drawer from an email link. */
(function () {
  'use strict';
  if (window.__callistoMailDrawer) return;
  window.__callistoMailDrawer = true;
  var entry = new URL(window.location.href);
  if (entry.searchParams.get('open_cart') !== '1') return;
  var started = Date.now();
  function open() {
    var wrapper = document.querySelector('.quick-cart__wrapper');
    if (wrapper && wrapper.classList.contains('active')) {
      entry.searchParams.delete('open_cart');
      window.history.replaceState(window.history.state, '', entry.pathname + entry.search + entry.hash);
      return;
    }
    var instances = (window.Shopify && window.Shopify.theme && window.Shopify.theme.sections && window.Shopify.theme.sections.instances) || [];
    var headerReady = false, cartReady = false;
    for (var i = 0; i < instances.length; i++) {
      if (instances[i].type === 'header') headerReady = true;
      if (instances[i].type === 'quick-cart') cartReady = true;
    }
    var trigger = document.querySelector('[data-header-cart]');
    if (headerReady && cartReady && trigger) trigger.click();
    if (Date.now() - started < 8000) window.setTimeout(open, 100);
  }
  if (document.readyState === 'complete') open();
  else window.addEventListener('load', function () { started = Date.now(); open(); }, { once: true });
})();
